import React, { useEffect, useState, useRef } from 'react'
import {
  Button,
  Flex,
  MainHeadline,
  ProfilePicture,
  Table,
  Th,
  Tr,
  PageWrapper,
  PageFooter,
  CursorPointer,
  ColoredDot,
  darkTheme,
} from '../../styling/GlobalStyles'
import { useNavigate } from 'react-router-dom'
import { Pagination } from '../../components/Pagination/Pagination'
import Avatar from '../../assets/images/profileAvatar.png'
import { Rating } from './Rating'
import { NavBar } from '../../components/NavBar/NavBar'
import { useDispatch, useSelector } from 'react-redux'
import {
  addUser,
  clearEmployeesList,
  deleteUser,
  getUsersSimpleInfo,
  getUserStats,
} from 'features/users(Employees)/usersSlice'
import { AppDispatch, RootState } from 'store'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { handlePagination, getParams } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import { setConfirmModal } from 'features/global/globalSlice'
import useAuth from 'hooks/useAuth'
import { ModalTypes } from 'types/global.interface'
import { Modal } from 'components/Modal/Modal'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { ImageModalFrame } from './Employees.styled'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'
import useQueryPagination from 'hooks/useQueryPagination'
import { contractTypes } from './employeesData'
import { ImportEmployeesModal } from './ImportEmployeesModal'
import { BodyText, OtherText } from 'styling/Typography'
import { attendanceTypesOptions } from 'pages/Attendance/data'
import { TerminateContractModal } from './TerminateContractModal'
import { ISingleEmployeePostRequest } from 'types/api/usersApi.interface'

export const Employees = () => {
  const { users, totalPages } = useSelector((store: RootState) => store.users)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { user } = useAuth()
  const [params, setParams] = useState<any>(getParams({ location }))
  const [imageModal, setImageModal] = useState({ isOpen: false, image: null })
  const [importModal, setImportModal] = useState(false)
  const [terminateContractModal, setTerminateContractModal] = useState({ open: false, id: null })

  useQueryPagination({
    fetchFunctions: [getUsersSimpleInfo, getUserStats],
    cleanUpFunctions: [clearEmployeesList],
    params,
  })

  const filters = [
    {
      type: FilterEnum.FIXED_LIST,
      name: 'State',
      state: null,
      propName: 'state',
      sd: true,
      single: true,
      filterOptions: [
        {
          name: 'Active',
          id: '1',
        },
        {
          name: 'Contract Terminated',
          id: '3',
        },
      ],
    },
    {
      type: FilterEnum.FIXED_LIST,
      name: 'Employee Type',
      state: null,
      propName: 'filterType',
      sd: true,
      single: true,
      filterOptions: [
        {
          name: 'Company',
          id: '1',
        },
        {
          name: 'Contractors',
          id: '2',
        },
      ],
    },
    {
      type: FilterEnum.SEARCH,
      link: LinkEnum.ROLES,
      name: 'Roles',
      state: null,
    },
    {
      type: FilterEnum.SEARCH,
      link: LinkEnum.OPERATION_TYPES,
      name: 'Operation Types',
      state: null,
      companyId: true,
    },
  ]

  const handleDelete = (id: number | string) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteUser(id))
          dispatch(getUserStats())
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: users.length < 2,
        },
        word: 'delete employee',
      }),
    )
  }

  const ImageModal = () => {
    const imageModalRef = useRef(null)

    useEffect(() => {
      const outSideClick = (e) => {
        if (!imageModalRef.current.contains(e.target)) {
          setImageModal({ isOpen: false, image: null })
        }
      }

      document.addEventListener('mousedown', outSideClick)

      return () => {
        document.removeEventListener('mousedown', outSideClick)
      }
    }, [])

    return (
      <Flex column gap='2rem' ref={imageModalRef}>
        <Flex end='true' width='100%'>
          <CursorPointer onClick={() => setImageModal({ isOpen: false, image: null })}>
            <CloseIcon />
          </CursorPointer>
        </Flex>

        <ImageModalFrame>
          <img
            src={imageModal.image || Avatar}
            alt='profile-image'
            onError={({ currentTarget }) => (currentTarget.src = Avatar)}
          />
        </ImageModalFrame>
      </Flex>
    )
  }

  const handleAddEa = async () => {
    const employees = [
      {
        nationalId: '104875362',
        firstName: 'Kwame',
        drivingLicense: { isActive: true, validUntil: '2027-05-14', drivingCategories: ['C'] },
        lastName: 'Osei',
        contact: { email: 'kwame.osei@company.com', phoneNumber: '+233245123456' },
        gender: 'm',
        maritalStatus: 'married',
        dateOfBirth: '1992-03-12',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 1850,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'kwame.osei',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233245123400',
          firstName: 'Abena',
          lastName: 'Osei',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Kofi',
        drivingLicense: { isActive: true, validUntil: '2028-11-20', drivingCategories: ['C'] },
        lastName: 'Mensah',
        contact: { email: 'kofi.mensah@company.com', phoneNumber: '+233201234567' },
        gender: 'm',
        maritalStatus: 'single',
        dateOfBirth: '1995-07-25',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 2100,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'kofi.mensah',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233201234001',
          firstName: 'Esi',
          lastName: 'Mensah',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Ama',
        drivingLicense: { isActive: true, validUntil: '2030-02-10', drivingCategories: ['C'] },
        lastName: 'Asante',
        contact: { email: 'ama.asante@company.com', phoneNumber: '+233541112223' },
        gender: 'f',
        maritalStatus: 'married',
        dateOfBirth: '1990-11-05',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 2300,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'ama.asante',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233541112002',
          firstName: 'Luca',
          lastName: 'Asante',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Luca',
        drivingLicense: { isActive: true, validUntil: '2026-12-15', drivingCategories: ['C'] },
        lastName: 'Appiah',
        contact: { email: 'luca.appiah@company.com', phoneNumber: '+233271239876' },
        gender: 'm',
        maritalStatus: 'single',
        dateOfBirth: '1989-01-30',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 1950,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'luca.appiah',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233271239003',
          firstName: 'Efua',
          lastName: 'Appiah',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Ekow',
        drivingLicense: { isActive: true, validUntil: '2029-08-04', drivingCategories: ['C'] },
        lastName: 'Baidoo',
        contact: { email: 'ekow.baidoo@company.com', phoneNumber: '+233244123123' },
        gender: 'm',
        maritalStatus: 'married',
        dateOfBirth: '1987-04-12',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 2500,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'ekow.baidoo',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233244123004',
          firstName: 'Araba',
          lastName: 'Baidoo',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Akua',
        drivingLicense: { isActive: true, validUntil: '2028-03-22', drivingCategories: ['C'] },
        lastName: 'Kumi',
        contact: { email: 'akua.kumi@company.com', phoneNumber: '+233509876543' },
        gender: 'f',
        maritalStatus: 'single',
        dateOfBirth: '1998-10-18',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 1700,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'akua.kumi',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233509876005',
          firstName: 'Kojo',
          lastName: 'Kumi',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Samuel',
        drivingLicense: { isActive: true, validUntil: '2027-12-31', drivingCategories: ['C'] },
        lastName: 'Adu',
        contact: { email: 'samuel.adu@company.com', phoneNumber: '+233246000111' },
        gender: 'm',
        maritalStatus: 'married',
        dateOfBirth: '1985-05-20',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 2800,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'samuel.adu',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233246000006',
          firstName: 'Mary',
          lastName: 'Adu',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Paa',
        drivingLicense: { isActive: true, validUntil: '2029-06-15', drivingCategories: ['C'] },
        lastName: 'Kwesi',
        contact: { email: 'paa.kwesi@company.com', phoneNumber: '+233200998877' },
        gender: 'm',
        maritalStatus: 'single',
        dateOfBirth: '1993-09-02',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 2050,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'paa.kwesi',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233200998007',
          firstName: 'Grace',
          lastName: 'Kwesi',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Abena',
        drivingLicense: { isActive: true, validUntil: '2030-01-01', drivingCategories: ['C'] },
        lastName: 'Dankwa',
        contact: { email: 'abena.dankwa@company.com', phoneNumber: '+233544332211' },
        gender: 'f',
        maritalStatus: 'married',
        dateOfBirth: '1991-02-14',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 2200,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'abena.dankwa',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233544332008',
          firstName: 'Kwadwo',
          lastName: 'Dankwa',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
      {
        nationalId: '104875362',
        firstName: 'Emmanuel',
        drivingLicense: { isActive: true, validUntil: '2028-09-09', drivingCategories: ['C'] },
        lastName: 'Tetteh',
        contact: { email: 'emmanuel.tetteh@company.com', phoneNumber: '+233243556677' },
        gender: 'm',
        maritalStatus: 'single',
        dateOfBirth: '1996-12-20',
        departmentId: 67,
        foodDietaryPreferenceType: 2,
        accessType: 'worker',
        contracts: [
          {
            startDate: '2026-01-01T11:00:00.000Z',
            endDate: '2026-12-31T11:00:00.000Z',
            signed: false,
            type: 1,
            value: 1600,
            logisticsInfo: {
              hasFoodProvided: false,
              hasFoodAllowance: false,
              foodAllowanceInCompanyAmount: 0,
              foodAllowanceOutCompanyAmount: 0,
              hasAccommodationProvided: false,
              hasAccommodationAllowance: false,
              accomodationTierPolicy: null,
              accomodationAllowanceInCompanyAmount: 0,
              accomodationAllowanceOutCompanyAmount: 0,
              transportationType: 1,
              hasTransportationAllowance: false,
              transportationAllowanceInCompanyAmount: 0,
              transportationAllowanceOutCompanyAmount: 0,
              hasResponsibilityAllowance: false,
              responsibilityAllowanceInCompanyAmount: 0,
              responsibilityAllowanceOutCompanyAmount: 0,
              hasExtraDutyAllowance: false,
              extraDutyAllowanceInCompanyAmount: 0,
              extraDutyAllowanceOutCompanyAmount: 0,
              accommodationId: null,
              transportationVehicleId: null,
              transportationTransferPointId: null,
              foodMealSupplierId: null,
            },
            workScheduleIntervalStartDate: '2026-01-01T11:00:00.000Z',
            freeDays: [7],
            workScheduleModelId: 35,
            shifts: [{ shiftId: 154, order: 1, shiftName: 'Day Shift' }],
            shiftChangeType: null,
            shiftChangeInterval: null,
            vacationDays: 21,
            departmentId: 1564,
            accomodationTierPolicy: null,
            shouldPayOvertime: false,
          },
        ],
        nationality: 'Ghanaian',
        profileImage: false,
        username: 'emmanuel.tetteh',
        emergencyContact: {
          type: 1,
          phoneNumber: '+233243556009',
          firstName: 'Comfort',
          lastName: 'Tetteh',
        },
        educationLevelType: 3,
        shouldSendTemporaryPassword: true,
      },
    ]

    for (const e of employees) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      await dispatch(addUser(e))
    }
  }

  return (
    <>
      <NavBar
        enableTemporaryManualClosing={true}
        filterOptions={filters}
        params={params}
        defaultValue={params.q}
        input
        placeholder='Search Employees...'
        setParams={setParams}
        limit={30}
      />
      <PageWrapper noFooter={totalPages < 2}>
        <Flex between center mb='16'>
          <MainHeadline>Employees</MainHeadline>
          <Flex gap='1rem'>
            <Button orange onClick={() => setImportModal(true)}>
              Import Employees
            </Button>
            <Button orange onClick={() => navigate('/hr/employees/add')}>
              Add Employee
            </Button>{' '}
            <Button orange onClick={handleAddEa}>
              das
            </Button>
          </Flex>
        </Flex>
        {!users?.length ? (
          <NoItems title='Employees' />
        ) : (
          <Table>
            <Th next>
              <Td w='6%' noTooltip text='ID' />
              <Td w='5%' noTooltip text='' />
              <Td w='15%' noTooltip text='Full Name' />
              <Td w='15%' noTooltip text='Phone' />
              <Td w='15%' noTooltip text='Net Salary' />
              <Td w='15%' noTooltip text='Accommodation' />
              <Td w='13%' noTooltip text='Rating' />
              <Td w='13%' noTooltip text='Status' />
              <Td w='5%' noTooltip text='' />
            </Th>
            {users &&
              users.map((item) => {
                const attendanceType = attendanceTypesOptions.find(
                  (a) => a.value == item.attendanceType,
                )
                return (
                  <Tr
                    view
                    style={{ cursor: 'pointer' }}
                    key={item.id}
                    onClick={() =>
                      navigate('/dashboard/employees/' + item.id + '?fromEmployees=true')
                    }
                  >
                    <Td w='6%'>
                      <BodyText>{item.accessCardId || '/'}</BodyText>
                    </Td>
                    <Td w='5%' noTooltip>
                      <Flex center>
                        <ProfilePicture>
                          <img
                            src={item.getImagePresignedUrl || Avatar}
                            alt=''
                            onClick={() =>
                              setImageModal({ isOpen: true, image: item.getImagePresignedUrl })
                            }
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null
                              currentTarget.src = Avatar
                            }}
                          />
                        </ProfilePicture>
                      </Flex>
                    </Td>
                    <Td w='15%'>
                      <Flex column style={{ maxWidth: '100%', overflow: 'hidden' }}>
                        <BodyText
                          weight='bold'
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '100%',
                          }}
                        >
                          {item?.fullName}
                        </BodyText>
                        <OtherText>{item?.role}</OtherText>
                      </Flex>
                    </Td>
                    <Td w='15%'>
                      <Flex column>
                        <BodyText>{item?.phoneNumber}</BodyText>
                        {item?.secondaryPhoneNumber && (
                          <BodyText>{item?.secondaryPhoneNumber}</BodyText>
                        )}
                      </Flex>
                    </Td>
                    <Td w='15%'>
                      <BodyText>
                        {item.contract?.value
                          ? 'GH₵ ' +
                          item.contract?.value +
                          ' ' +
                          contractTypes.find((c) => c.value == item.contract?.type).label
                          : 'No active contracts'}
                      </BodyText>
                    </Td>
                    <Td w='15%'>
                      <BodyText>{item?.accommodation?.name || 'No Accommodation'}</BodyText>
                    </Td>
                    <Td w='13%' noTooltip>
                      <Rating rating={item.overallRating?.toFixed(1)} />
                    </Td>
                    <Td w='13%' noTooltip>
                      <Flex gap='1rem' center>
                        {attendanceType && (
                          <ColoredDot
                            color={
                              attendanceType.color ? darkTheme[attendanceType.color] : '#ff9900'
                            }
                          />
                        )}
                        {/* TODO: Ubaciti gore i za light temu */}
                        {attendanceType?.label || 'Not Set'}
                      </Flex>
                    </Td>
                    <Td
                      w='5%'
                      options
                      noTooltip
                      onClick={(e) => {
                        e.stopPropagation()
                        return null
                      }}
                    >
                      <Options
                        item={item}
                        invisible={user.id == item.id}
                        title='Employee'
                        handleRemove={() => handleDelete(item.id)}
                        openModal={(id) => setTerminateContractModal({ open: true, id })}
                      />
                    </Td>
                  </Tr>
                )
              })}
          </Table>
        )}
        {imageModal.isOpen && (
          <Modal black>
            <ImageModal />
          </Modal>
        )}
        {importModal && <ImportEmployeesModal closeModal={() => setImportModal(false)} />}
        {terminateContractModal.open && (
          <TerminateContractModal
            id={terminateContractModal.id}
            closeModal={() => setTerminateContractModal({ open: false, id: null })}
          />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
